<template>
    <Field :name="name" :rules="rules" :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        v-slot="{ errors, field }" :validateOnInput="triggered">
        <select v-if="type == 'select'" v-bind="$attrs"
            @change="$emit('update:modelValue', $event.target.value);" :class="inputClass(errors)">
            <option v-if="modelValue === null || modelValue === undefined" hidden disabled selected value="">{{ placeholder }}
            </option>
            <slot></slot>
        </select>
        <input v-else :type="type" :placeholder="placeholder" v-bind="{ ...$attrs, ...field }" :class="inputClass(errors)" />
    </Field>
    <ErrorMessage :name="name" />
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate';

export default {
    inheritAttrs: false,
    data: () => ({
        triggered: false,
    }),
    components: {
        Field,
        ErrorMessage,
    },
    props: {
        placeholder: String,
        type: {
            type: String,
            default: "text",
        },
        name: String,
        modelValue: [String, Number, Boolean],
        rules: [Object,String],
    },
    methods: {
        inputClass(errors) {
            if (errors.length) {
                this.triggered = true;
                return "error";
            }
            return "";
        }
    },
}
</script>
